import { render, staticRenderFns } from "./OtherProjectCard.vue?vue&type=template&id=4c364c44&scoped=true&"
import script from "./OtherProjectCard.vue?vue&type=script&lang=js&"
export * from "./OtherProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./OtherProjectCard.vue?vue&type=style&index=0&id=4c364c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c364c44",
  null
  
)

export default component.exports